<template>
  <v-sheet class="mx-auto" elevation="0" max-width="500">
    <v-slide-group v-model="model" class="pa-4" show-arrows>
      <v-slide-item
        v-for="(color, i) in thems[type]"
        :key="i"
        v-slot="{ active, toggle }"
      >
        <ul
          @click="toggle"
          :style="{
            width: '130px',
            height: '200px',
            borderRadius: '10px',
            margin: '0',
            padding: '0',
            margin: '1rem',
            cursor: 'pointer',
            position: 'relative',
          }"
        >
          <li
            :style="{
              listStyle: 'none',
              width: '100%',
              height: '40%',
              background: color.backgroundColor,
              borderTopLeftRadius: '50px',
            }"
          ></li>
          <li
            :style="{
              listStyle: 'none',
              width: '100%',
              height: '30%',
              background: color.componentsColor,
            }"
          ></li>
          <li
            :style="{
              listStyle: 'none',
              width: '100%',
              height: '20%',
              background: color.iconColor,
            }"
          ></li>
          <li
            :style="{
              listStyle: 'none',
              width: '100%',
              height: '10%',
              background: color.textColor,
              borderBottomRightRadius: '50px',
            }"
          ></li>
          <li
            :style="{
              listStyle: 'none',
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: '0',
              background: '#ffffff4d',
              display: active ? 'flex' : 'none',
              justifyContent: 'center',
              borderBottomRightRadius: '50px',
              borderTopLeftRadius: '50px',
            }"
          >
            <v-icon color="success">mdi-check-circle-outline</v-icon>
          </li>
        </ul>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>
<script>
export default {
  name: "choseDefaultThem",
  props: {
    value: [Object, Array],
    type: String,
  },
  data: () => ({
    model: 0,
    thems: {
      dark: [
        {
          backgroundColor: "#092635",
          componentsColor: "#1B4242",
          iconColor: "#5C8374",
          textColor: "#9EC8B9",
          tagColor: "",
        },
        {
          backgroundColor: "#27374D",
          componentsColor: "#526D82",
          iconColor: "#9DB2BF",
          textColor: "#DDE6ED",
          tagColor: "",
        },
        {
          backgroundColor: "#181C14",
          componentsColor: "#3C3D37",
          iconColor: "#697565",
          textColor: "#ECDFCC",
          tagColor: "",
        },
        {
          backgroundColor: "#3E3232",
          componentsColor: "#503C3C",
          iconColor: "#7E6363",
          textColor: "#A87C7C",
          tagColor: "",
        },
        {
          backgroundColor: "#EEB76B",
          componentsColor: "#E2703A",
          iconColor: "#9C3D54",
          textColor: "#310B0B",
          tagColor: "",
        },
      ],
      light: [
        {
          backgroundColor: "#F8FAFC",
          componentsColor: "#D9EAFD",
          iconColor: "#BCCCDC",
          textColor: "#9AA6B2",
          tagColor: "",
        },
        {
          backgroundColor: "#ECEBDE",
          componentsColor: "#C1BAA1",
          iconColor: "#D7D3BF",
          textColor: "#A59D84",
          tagColor: "",
        },
        {
          backgroundColor: "#FFEFEF",
          componentsColor: "#F0EBE3",
          iconColor: "#F3D0D7",
          textColor: "#F6F5F2",
          tagColor: "",
        },
        {
          backgroundColor: "#F8F6F4",
          componentsColor: "#D2E9E9",
          iconColor: "#E3F4F4",
          textColor: "#C4DFDF",
          tagColor: "",
        },
        {
          backgroundColor: "#FFF8E1",
          componentsColor: "#C0DEFF",
          iconColor: "#FFE5F1",
          textColor: "#ADA2FF",
          tagColor: "",
        },
      ],
    },
  }),

  watch: {
    model(val) {
      this.value[this.type] = this.thems[this.type][val ?? 0];
    },
  },
};
</script>
<style scoped>
li {
  list-style: none;
}
</style>
